import { Heading, Img } from "./..";
import React, { Suspense } from "react";
import AccesoriesCheckList from "../../components/AccesoriesCheckList";
import AddPageProviderRow1 from "../../components/AddPageProviderRow1";

export default function AddPageProviderRow2({
  car,
  toggleTab,
  index,
  activeTab,
  blocktitle = "מידע על העיסקה",
  accessoriesSelected,
  setAccessoriesSelected,
  currentUser,
  ...props
}) {
  // ✅ ספק = user_type 2
  const isProvider = Number(currentUser?.user_type) === 2;
const formatDateIL = (v) => {
  if (!v) return "";
  // תומך גם "2024-08-06T00:00:00" וגם "2024-08-06 00:00:00"
  const d = new Date(String(v).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) {
    // fallback אם הגיע רק YYYY-MM-DD
    const s = String(v).split("T")[0].split(" ")[0];
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
      const [y, m, day] = s.split("-");
      return `${day}-${m}-${y}`;
    }
    return String(v);
  }
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};

  const carDetails = [
    // 0 - פרטי הרכב
    [
      { value: car?.license_plate, label: "מס' רישוי", img: "/images/black-car.svg" },
      { value: car?.manufacturer, label: "יצרן", img: "/images/black-car.svg" },
      { value: car?.model, label: "דגם", img: "/images/black-car.svg" },
      { value: car?.year, label: "שנת ייצור", img: "/images/img_calendar.svg" },
      { value: car?.hand, label: "יד", img: "/images/img_artboard_2_copy_3_black_900_03_3.svg" },
      { value: car?.original_ownership, label: "בעלות מקורית", img: "/images/img_vector_black_900_03_1.svg" },
      { value: car?.kilometer, label: "ק'מ", img: "/images/img_artboard_2_copy_6.svg" },
      { value: formatDateIL(car?.test_date), label: "תאריך טסט", img: "/images/img_calendar.svg" },

    ],

    // 1 - מפרט טכני
    [
      { value: car?.chassis_number, label: "מס' שילדה", img: "/images/img_artboard_2_copy_6.svg" },
      { value: car?.finish_level, label: "רמת גימור", img: "/images/img_artboard_2_copy_6.svg" },
      { value: car?.gearbox, label: "תיבת הילוכים", img: "/images/img_vector_black_900_03_1.svg" },
      { value: car?.color, label: "צבע", img: "/images/img_contrast_black_900_03_4.svg" },
      { value: car?.car_type, label: "סוג רכב", img: "/images/black-car.svg" },

    ],

    // 2 - מנוע וביצועים
    [
      { value: car?.engine_type, label: "מנוע", img: "/images/img_icon_black_900_01.svg" },
      { value: car?.engine_capacity, label: "נפח מנוע", img: "/images/img_artboard_2_copy_6.svg" },
    ],

    // 3 - אבזור ונוחות (לא משתמשים כאן, יש קומפוננטה אחרת)
    [],

    // 4 - מידע על העיסקה (אם תחזירי את הטאב הזה בעתיד)
    [
      { value: car?.askingPrice, label: "תאריך כניסה", img: "/images/img_signal_black_900_03_1.svg" },
      { value: car?.askingPrice, label: "תאריך איסוף", img: "/images/img_signal_black_900_03_1.svg" },
      { value: car?.askingPrice, label: "מיקום העיסקה", img: "/images/img_signal_black_900_03_1.svg" },
      { value: car?.askingPrice, label: "אחריות מהסוכנות", img: "/images/img_signal_black_900_03_1.svg" },
      { value: car?.askingPrice, label: "התחיבות לבדיקות", img: "/images/img_signal_black_900_03_1.svg" },
      { value: car?.askingPrice, label: "תאריך תשלום אחרון", img: "/images/img_signal_black_900_03_1.svg" },
      { value: car?.askingPrice, label: "התחיבות", img: "/images/img_signal_black_900_03_1.svg" },
    ],
  ];

  // ✅ הכי חשוב: משתמשים ב-index (של הבלוק), לא ב-activeTab
  const baseList = carDetails[index] || [];

  // ✅ מסתירים רק את "מס' רישוי" אם זה לא ספק
  const detailsForThisBlock = baseList.filter((item) => {
    if (item?.label === "מס' רישוי" && !isProvider) return false;
    return true;
  });

  return (
    <>
      {/* Header (כמו שהיה אצלך) */}
      <div
        {...props}
        onClick={() => toggleTab(index)}
        style={{ backgroundColor: activeTab === index ? "#f7f7f7" : "" }}
        className={`vehicle-details-accordion ${props.className} cursor-pointer flex justify-center items-center self-stretch gap-[50px] p-5 border-blue_gray-100 border border-solid bg-secondary-primary_white flex-1 rounded-md`}
        data-testid="vehicle-details-accordion-item"
      >
        <Img
          src={activeTab === index ? `/images/img_checkmark_black.svg` : `/images/img_arrow_left_white.svg`}
          className="h-[22px] self-start"
        />
        <div className="flex flex-1 justify-end">
          <Heading size="ass_20" as="h5" className="text-[20px] font-semibold">
            {blocktitle}
          </Heading>
        </div>
      </div>

      {/* Body */}
      {activeTab === index && (
        <div className="flex items-start p-2 md:flex-col" dir="rtl">
          <div className="flex flex-1 gap-[164px] md:flex-row md:self-stretch sm:flex-col" />
          <div className="flex w-full flex-col gap-[22px] self-center dir-rtl">
            {blocktitle !== "אבזור ונוחות" ? (
              <div className="grid grid-cols-3 gap-[22px] md:grid-cols-2 sm:grid-cols-1">
                <Suspense fallback={<div>Loading...</div>}>
                  {detailsForThisBlock.map((item, idx) => (
                    <AddPageProviderRow1 {...item} key={"list1-" + idx} />
                  ))}
                </Suspense>
              </div>
            ) : (
              <AccesoriesCheckList
                selected={accessoriesSelected}
                setSelected={setAccessoriesSelected}
                disabled={true}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
